import { httpClient } from '@/services/http/httpClient'
import { Actors } from '@/types/actors'

import type { User } from '../../usersService/types'

type SSOLoginParams = {
  idToken: string
}

type SSOLoginResponse = {
  token: string
  user: User
}

export async function ssoLogin({
  idToken,
}: SSOLoginParams): Promise<SSOLoginResponse> {
  const { data } = await httpClient.post('/users/sessions/sso-microsoft', {
    idToken,
  })

  return {
    token: data.token,
    user: {
      id: data.user.id,
      registration: data.user.registration,
      name: data.user.name,
      ...(data.user.email && {
        email: data.user.email,
      }),
      ...(data.user?.image && {
        profilePhoto: data.user?.image,
      }),
      ...(data.user.area && {
        area: {
          id: data.user.area.id,
          name: data.user.area.name,
        },
      }),
      isFirstAccess: data.user.firstAccess === null,
      isAcceptedTerms: data.user.acceptedTerms
        ? !Number.isNaN(new Date(data.user.acceptedTerms).getTime()) // Verifica se acceptedTerms é uma data válida
        : false,
      role:
        data.user.isManager || data.user.isAdmin
          ? Actors.MANAGER
          : Actors.IDEATOR,
      rank: data.user.rank ?? 0,
      points: data.user.points ?? 0,
    },
  }
}
